import toast from "react-hot-toast";
import React from "react";
import { TeeToast } from "@/components/ui/tee-toast";

export type ToastType = "success" | "error";
export type ToastVariant = "fill" | "outline";

export interface ShowToastOptions {
  message: string;
  type?: ToastType;
  variant?: ToastVariant;
  duration?: number;
}

/**
 * Display a toast notification using TeeToast component
 * @param options - Toast configuration options
 */
export const showToast = (options: ShowToastOptions) => {
  const {
    message,
    type = "success",
    variant = "fill",
    duration = 4000,
  } = options;

  toast.custom(
    (toastObj) =>
      React.createElement(TeeToast, {
        message,
        type,
        variant,
        onDismiss: () => toast.dismiss(toastObj.id),
      }),
    {
      duration,
      position: "top-right",
    },
  );
};

/**
 * Display a success toast
 * @param message - Toast message
 * @param duration - Toast duration in milliseconds (default: 4000)
 */
export const showSuccessToast = (message: string, duration?: number) => {
  showToast({
    message,
    type: "success",
    variant: "fill",
    duration,
  });
};

/**
 * Display an error toast
 * @param message - Toast message
 * @param duration - Toast duration in milliseconds (default: 4000)
 */
export const showErrorToast = (message: string, duration?: number) => {
  showToast({
    message,
    type: "error",
    variant: "fill",
    duration,
  });
};
